import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ToastEffects } from './toast.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ToastEffects])],
})
export class ToastStoreModule {}
